import { useState, useEffect } from 'react';
import { JOKI } from '../../JOKI';
import useConfig from '../Config/configHooks';

export default function useCurrentUser() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        JOKI.ask({
            to: 'UserService',
            key: 'getCurrentUser',
        }).then(user => {
            if (user.UserService !== undefined) {
                setUser(user.UserService);
            }
        });
    }, []);

    useEffect(() => {
        return JOKI.on({
            from: 'UserService',
            key: 'currentUserUpdated',
            fn: event => {
                if (event.from === 'UserService' && event.key === 'currentUserUpdated' && event.body !== undefined) {
                    if (event.body.name !== undefined) {
                        setUser(event.body);
                    }
                }
            },
        });
    });
    return user;
}

export function useCurrentUserAccessibility() {
    const [user, setUser] = useState(null);
    const mainAdminRole = useConfig('mainAdminRole');
    const organizationCRUDRoles = useConfig('organizationCRUDRoles');
    const locationCRUDRoles = useConfig('locationCRUDRoles');
    const deviceManagementRoles = useConfig('deviceManagementRoles');
    const AlertNotificationSettingsRoles = useConfig('AlertNotificationSettingsRoles');

    const [permissionState, setPermissionState] = useState('Loading');
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        JOKI.ask({
            to: 'UserService',
            key: 'getCurrentUser',
        }).then(user => {
            if (user.UserService !== undefined) {
                setUser(user.UserService);
            }
        });
    }, []);

    useEffect(() => {
        return JOKI.on({
            from: 'UserService',
            key: 'currentUserUpdated',
            fn: event => {
                if (event.from === 'UserService' && event.key === 'currentUserUpdated' && event.body !== undefined) {
                    if (event.body.name !== undefined) {
                        setUser(event.body);
                    }
                }
            },
        });
    }, []);

    useEffect(() => {
        // Functions for checking a combination of roles and accessScopes to see if the user can access to certain content.
        function roleIsAdminRole(user) {
            function roleMatching(roles) {
                return roles.some(role => mainAdminRole.find(v => v.role === role));
            }
            function accessScopeMatching(accessScope) {
                return mainAdminRole.some(v => v.accessScope === accessScope);
            }
            return roleMatching(user.roles) && accessScopeMatching(user.accessScope);
        }

        function hasOrganizationCRUDPermission(user) {
            function accessScopeMatching(accessScope) {
                return mainAdminRole.some(v => v.accessScope === accessScope);
            }
            return organizationCRUDRoles.some(ocr => user.roles.includes(ocr.role)) && accessScopeMatching(user.accessScope);
        }

        function hasLocationCRUDPermission(user) {
            const isLocationRestricted = user && user.modules && Array.isArray(user.modules) && user.modules.length > 0;
            return !isLocationRestricted && locationCRUDRoles.some(lcr => user.roles.includes(lcr.role));
        }

        function hasDeviceManagementPermission(user) {
            return deviceManagementRoles.some(dmr => user.roles.includes(dmr.role));
        }
        
        function hasAlertNotificationSettingsPermission(user){
            return AlertNotificationSettingsRoles.some(ans => user.roles.includes(ans.role))
        }

        // Using the functions to create permissions array.
        // NOTE: If the user does not have any scopes, i.e. the accessScope is null and they can see the minimum amount of information possible.
        if (user && user.roles && user.accessScope) {
            const permissionList = [];
            if (roleIsAdminRole(user)) {
                permissionList.push('globalAdmin');
            }
            if (hasOrganizationCRUDPermission(user)) {
                permissionList.push('organizationCRUD');
            }
            if (hasLocationCRUDPermission(user)) {
                permissionList.push('locationCRUD');
            }
            if (hasDeviceManagementPermission(user)) {
                permissionList.push('deviceManagement');
            }
            if(hasAlertNotificationSettingsPermission(user)){
                permissionList.push('alertNotificationSettings')
            }
            setPermissions(permissionList);
            setPermissionState('Loaded');
        }
    }, [user, mainAdminRole, organizationCRUDRoles, locationCRUDRoles, deviceManagementRoles, AlertNotificationSettingsRoles]);

    return  {permissions, permissionState, user};
}
/*
export function useCurrentUserIsAdmin() {
    const [user, setUser] = useState(null);
    const mainAdminRole = useConfig('mainAdminRole');
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        JOKI.ask({
            to: 'UserService',
            key: 'getCurrentUser',
        }).then(user => {
            if (user.UserService !== undefined) {
                setUser(user.UserService);
            }
        });
    }, []);

    useEffect(() => {
        return JOKI.on({
            from: 'UserService',
            key: 'currentUserUpdated',
            fn: event => {
                if (event.from === 'UserService' && event.key === 'currentUserUpdated' && event.body !== undefined) {
                    if (event.body.name !== undefined) {
                        setUser(event.body);
                    }
                }
            },
        });
    }, []);

    useEffect(() => {
        function roleIsAdminRole(user) {
            function roleMatching(roles) {
                return roles.some(role => mainAdminRole.find(v => v.role === role));
            }

            function accessScopeMatching(accessScope) {
                return mainAdminRole.some(v => v.accessScope === accessScope);
            }

            return roleMatching(user.roles) && accessScopeMatching(user.accessScope);
        }

        if (user && user.roles && user.accessScope) {
            setIsAdmin(roleIsAdminRole(user));
        }
    }, [user, mainAdminRole]);

    return isAdmin;
}
*/
